import React from 'react';
import Opportunities from '../opportunities';

const Callforproposal = () => {


  
  return (
   <Opportunities
   pageTitle="Call for Proposal"
  metaTitle="Call for Proposal - FORLAND"
  bannerImage="assets/images/bg1.png"
  breadcrumb="Call for Proposal"
  category='proposal'
    />
  );
};

export default Callforproposal;
